<script setup lang="ts">
/**
 * Toast Error
 * --------------------------------
 * Error toast with red background
 */

const { toast } = defineProps<{
    toast: Toast;
}>();
</script>

<template>
    <Toast :toast="toast" class="bg-error text-white">
        <template #icon>
            <Icon name="tot:alert" class="size-4" />
        </template>
        <div v-html="toast.message" />
    </Toast>
</template>
